export type BadgeVariant = "success" | "danger" | "warning" | "info" | "neutral";

interface BaseBadgeProps {
  variant: BadgeVariant;
  label: string;
  dot?: boolean;
}

const variantStyles: Record<BadgeVariant, string> = {
  success: "bg-(--color-success-bg) text-(--color-success-text) border-(--color-success)",
  danger: "bg-(--color-danger-bg) text-(--color-danger-text) border-(--color-danger)",
  warning: "bg-(--color-warning-bg) text-(--color-warning-text) border-(--color-warning)",
  info: "bg-(--color-info-bg) text-(--color-info-text) border-(--color-info)",
  neutral: "bg-(--color-surface-2) text-(--color-text-secondary) border-(--color-border)",
};

const dotStyles: Record<BadgeVariant, string> = {
  success: "bg-(--color-success)",
  danger: "bg-(--color-danger)",
  warning: "bg-(--color-warning)",
  info: "bg-(--color-info)",
  neutral: "bg-(--color-text-tertiary)",
};

export const BaseBadge = ({variant, label, dot = false}: BaseBadgeProps) => (
  <span
    className={[
      "inline-flex items-center gap-1.5 px-2 py-0.5 text-xs font-medium rounded-full border border-transparent",
      variantStyles[variant],
    ].join(" ")}
  >
    {dot && <span className={`inline-block w-1.5 h-1.5 rounded-full ${dotStyles[variant]}`} />}
    {label}
  </span>
);
